<template>
  <footer class="dark:bg-gray-900 dark:text-gray-300 pb-10">
    <div class="container mx-auto mt-2 mb-8 flex flex-col md:flex-row justify-between items-center">
      <div class="text-center md:text-left mb-4 md:mb-0">
        <p>&copy; {{ currentYear }} Буйян. Все права защищены.</p>
      </div>
      <div class="flex space-x-2 mb-4 md:mb-0">
        <a href="https://vk.com/" target="_blank" rel="noopener noreferrer" class="hover:text-gray-400">
          <svg class="w-6 h-6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
                d="M31.5 63.5C0 95 0 145.7 0 247V265C0 366.3 0 417 31.5 448.5C63 480 113.7 480 215 480H233C334.3 480 385 480 416.5 448.5C448 417 448 366.3 448 265V247C448 145.7 448 95 416.5 63.5C385 32 334.3 32 233 32H215C113.7 32 63 32 31.5 63.5zM75.6 168.3H126.7C128.4 253.8 166.1 290 196 297.4V168.3H244.2V242C273.7 238.8 304.6 205.2 315.1 168.3H363.3C359.3 187.4 351.5 205.6 340.2 221.6C328.9 237.6 314.5 251.1 297.7 261.2C316.4 270.5 332.9 283.6 346.1 299.8C359.4 315.9 369 334.6 374.5 354.7H321.4C316.6 337.3 306.6 321.6 292.9 309.8C279.1 297.9 262.2 290.4 244.2 288.1V354.7H238.4C136.3 354.7 78 284.7 75.6 168.3z"
            />
          </svg>
        </a>
      </div>
      <div class="text-center md:text-right">
        <div class="group relative inline-block">
          <span
              id="support-contact-hint"
              role="tooltip"
              class="pointer-events-none absolute bottom-full right-0 mb-3 w-72 rounded-lg bg-gray-900 px-3 py-2 text-left text-xs leading-relaxed text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100 dark:bg-gray-700"
          >
            Вы можете связаться с техподдержкой, предложить улучшение сайта или сообщить о найденной ошибке.
          </span>
          <button
              type="button"
              aria-describedby="support-contact-hint"
              class="inline-flex items-center gap-2 rounded-full border border-blue-400/70 px-4 py-2 text-sm font-medium text-blue-400 transition duration-200 hover:border-blue-300 hover:bg-blue-400/10 hover:text-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400/60 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900"
              @click="showContactModal = true"
          >
            <svg
                class="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
              <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>
              <path d="M8 10h8M8 14h5"/>
            </svg>
            <span>Напишите нам!</span>
          </button>
        </div>
      </div>
    </div>
    <BaseModal
        v-model="showContactModal"
        title="Напишите нам!"
        modal-class="w-full max-w-lg max-h-[90vh] overflow-y-auto"
    >
      <SupportContactForm :initial-email="initialEmail" @submitted="showContactModal = false" />
    </BaseModal>
  </footer>
</template>

<script setup>
import {computed, ref} from 'vue';
import {useUserStore} from '@/modules/user/store/userStore.js';
import BaseModal from '@/core/components/material/v1/modal/BaseModal.vue';
import SupportContactForm from '@/modules/support/components/SupportContactForm.vue';

const currentYear = ref(new Date().getFullYear());
const showContactModal = ref(false);
const userStore = useUserStore();
const initialEmail = computed(() => userStore.currentUser?.email || '');
</script>

<style scoped>
</style>
